
import React from "react";
import DataTable from 'react-data-table-component';

export default function CommanBarTable_Orion(props) {
  let data = props.data;
  let tabDataKey = props.tabDataKey;
  let noFifty = props.hasOwnProperty("noFifty");

  const columns = [
    {
      name: 'Vin Number',
      selector: (row) => row?.key?.vehicleId ?? "",
      sortable: true,
      width: '25%',
    },
    {
      name: 'Value',
      selector: (row) =>
        noFifty
          ? row?.[tabDataKey]?.value ?? 0
          : row?.[tabDataKey]?.values?.["50.0"] ?? 0,
      sortable: true,
      width: '15%',
      cell: (row) => {
        const value = noFifty
          ? row?.[tabDataKey]?.value
          : row?.[tabDataKey]?.values?.["50.0"];

        return (
          <span>
            {value != null ? Number(value).toFixed(2) : "0.00"}
          </span>
        );
      },
    },
    {
      name: 'Reg No',
      selector: (row) => row?.key?.vehicle_registration_number ?? "",
      sortable: true,
      width: '20%',
    },
    {
      name: 'Depot',
      selector: (row) => row?.key?.Depot_Name ?? "",
      sortable: true,
      width: '20%',
    },
    {
      name: 'City',
      selector: (row) => row?.key?.DLR_ORG_CITY ?? "",
      sortable: true,
      width: '20%',
    }
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#83A4CF',
        color: '#fff',
        fontWeight: 'bold'
      },
    },
  };

  return (
    <>
      <DataTable
        columns={columns}
        data={data ?? []}
        customStyles={customStyles}
        fixedHeader={true}
        fixedHeaderScrollHeight='250px'
      />
    </>
  );
}
